import { CampaignItemComponent } from './campaign-item.component';

export default angular
  .module('sfMobile.components.campaign-item', [
    'pascalprecht.translate',
    'sfMobile.services.dates',
  ])
  .component('sfCampaignItem', CampaignItemComponent).name;
